import { QuoteParameters } from "./quoteParams";

export interface VehicleData {
  makes?: Array<{ id: string; name: string }>;
  models?: Array<{ id: string; name: string }>;
  variants?: Array<{ id: string; name: string }>;
}

/**
 * Resolves vehicle names from IDs using available vehicle data
 * Note: This function currently only returns the original parameters since name parameters have been removed
 */
export const resolveVehicleNames = (
  params: QuoteParameters
): QuoteParameters => {
  // Since name parameters have been removed, we just return the original parameters
  // The vehicle names are resolved from the IDs when the form is populated
  return { ...params };
};

/**
 * Determines which vehicle data needs to be loaded based on parameters
 */
export const getRequiredVehicleData = (params: QuoteParameters) => {
  return {
    loadMakes: !!params.makeId,
    loadModels: !!params.makeId && !!params.modelId,
    loadVariants:
      !!params.makeId &&
      !!params.modelId &&
      !!params.modelYear &&
      !!params.variantId,
  };
};
